import { defineStore } from 'pinia'

import state from './state.js'
import getters from './getters.js'
import actions from './actions.js'

const useNotificationsStore = defineStore('notifications', {
  state,
  getters,
  actions,
})

export default useNotificationsStore
